import useDataStore from '@/store/data';
import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

export default function useLiveData(schema) {
  const [liveData, setLiveData] = useState([]);
  const { upsert, remove } = useDataStore();

  useEffect(() => {
    const socket = io(import.meta.env.VITE_LIVE_URL, {
      transports: ['websocket'],
      auth: {
        token: localStorage.getItem('accessToken'),
      },
      path: '/live',
    });

    socket.on('connect', () => {
      console.log('Connected to socket');
      socket.emit('subscribe', schema, (response) => {
        console.debug(response, `Subscribed to ${schema}`);
      });
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from socket');
    });

    socket.on('error', (error) => {
      console.error(error);
    });

    socket.on('update', (update, callback) => {
      if (typeof callback === 'function') callback({ status: 'ok' });
      if (update?.operationType === 'update') {
        upsert(update.data);
      } else if (update?.operationType === 'insert') {
        upsert(update.data);
      } else if (update?.operationType === 'delete') {
        remove(update.documentID, schema);
      }
      setLiveData((prev) => [...prev, update]);
    });

    return () => {
      socket.disconnect();
    };
  }, [schema]);

  return { liveData };
}
